import HomeTargetsAssociates from './HomeTargetsAssociatesPage';

export default HomeTargetsAssociates;
